<app-game-table-form
  title="Aggiungi tavolo"
  submitLabel="Crea Tavolo"
  [availableEvents]="availableEvents()"
  [availableOrganizations]="availableOrganizations()"
  (formSubmit)="onSubmit($event)"
  (cancel)="onCancel()">
</app-game-table-form>
